<template>
  <div>

    <topheader title="KONTAKT" underline="Schreiben Sie uns! Wir helfen Ihnen gerne!"> </topheader>

    <div class="container mt-5">
      <div class="row mb-3">

        <div class="col-md-5 col-xs-12">

          <h4>Kontaktformular</h4>
          <p>Bitte füllen Sie das Formular aus und klicken Sie auf <b>"Nachricht Absenden"</b>.</p>

          <hr>

          <h4>Bestellnummer</h4>
          <p>Wenn Sie bereits Kunde sind, so tragen Sie bitte die Bestellnummer des Marktplatzes ein oder nutzen
            Sie die orderID
          </p>

          <p>Sie finde diese Angaben auf Ihrer Rechnung oder dem Lieferschein auf dem Versandkarton!</p>

          <hr>

          <h4>Bearbeitungszeit</h4>
          <p>Bitte haben Sie verständnis dafür, dass eine bearbeitung Ihrer Anfrage bis zu 24Std. dauern kann.</p>

        </div>

        <!-- Space -->
        <div class="col-1"></div>

        <div class="col-md-6 col-xs-12">
          <contact-form v-if="!mailsend" @mailsend="mailsend=true" />
          <div v-else style="text-align: center">
            <h2>Sie haben es geschafft!</h2>

            <check-animation> </check-animation>

            <div class="mb-4"> <b>Vielen Dank für Ihre Mitarbeit!</b> </div>
            <p>
              Ihre Nachricht wurde unserem Kundenservice mitgeteilt und wir werden Ihren Fall schnellstmöglich bearbeiten!
            </p>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import ContactForm from "@/components/elements/ContactForm";
import TopHeader from '@/components/Header'
import Topheader from "@/components/Header";
import CheckAnimation from "@/components/elements/CheckAnimation";

export default {
  name: "Contact",
  components: {CheckAnimation, Topheader, ContactForm},
  comments:[
      ContactForm,
      TopHeader,
      CheckAnimation
  ],
  data() {
    return {
      mailsend: false
    }
  },
}
</script>

<style scoped>

</style>